import { FC } from 'react';
import { IoMdCloseCircle } from 'react-icons/io';
import { RiArrowDownSLine } from 'react-icons/ri';
import { Drawer } from 'vaul';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { LangEnum } from '../../../../../helpers/lang';
import { useLang } from '../../../../../hooks/use-lang';
import { FLAGS, LANG_OPTIONS } from '../constants';
import { LangList } from '../lang-list/lang-list';
import s from './mobile-lang-select.module.css';

const { Root, Trigger, Portal, Overlay, Content, Title } = Drawer;

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (lang: LangEnum) => void;
  selectedLang?: (typeof LANG_OPTIONS)[number];
}

export const MobileLangSelect: FC<Props> = ({ open, onOpenChange, selectedLang, onSelect }) => {
  const { currentLang, t } = useLang();

  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <Trigger asChild>
        <div className={s.trigger}>
          <button data-testid="header-lang">
            {FLAGS[currentLang]}
            {selectedLang?.mobileLabel}
            <RiArrowDownSLine />
          </button>
        </div>
      </Trigger>
      <Portal>
        <Overlay className={s.overlay} />
        <Content className={s.content} aria-describedby={undefined}>
          <div className={s.header}>
            <Title className={s.title}>{t('Сменить язык')}</Title>
            <IconButton className={s.button} variant="ghost" onClick={() => onOpenChange(false)}>
              <IoMdCloseCircle />
            </IconButton>
          </div>
          <LangList currentLang={currentLang} onSelect={onSelect} />
        </Content>
      </Portal>
    </Root>
  );
};
